/**
 * Kleine DOM-Helfer
 */
export const qs  = (sel, ctx = document) => ctx.querySelector(sel);
export const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

export function onReady(fn) {
	if (document.readyState !== 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn, { once: true });
	}
}

/** Alle direkten Body-Kinder außer den angegebenen inert schalten (für modale Overlays). */
export function setInertExcept(keep, inert) {
	Array.from(document.body.children).forEach((el) => {
		if (keep.includes(el) || el.tagName === 'SCRIPT') return;
		if (inert) el.setAttribute('inert', ''); else el.removeAttribute('inert');
	});
}

export const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
